module.exports = __webpack_public_path__ + "img/5-May.e17802b0.jpg";